// English UI copy for react-intl. Flat, dot-namespaced keys matching
// feature.component.messageName. Locale-invariant content (the "Lendcord"
// brand wordmark on its own, placeholder glyphs like "–"/"…", the "+91"
// country-code prefix, and the support email address) is intentionally not
// extracted here — it renders identically in every locale.
export default {
  // --- auth / BrandPanel ---
  "auth.brandPanel.heading": "Fast, transparent lending",
  "auth.brandPanel.subtitle":
    "Sign in to manage your loan, track repayments, and stay on top of your KYC — all in one place.",
  "auth.brandPanel.trustPoint1": "Clear terms, no hidden charges",
  "auth.brandPanel.trustPoint2": "Bank-grade security for your data",
  "auth.brandPanel.trustPoint3": "A simple, guided loan journey",

  // --- auth / CredentialsForm ---
  "auth.credentialsForm.firstNameLabel": "First name",
  "auth.credentialsForm.firstNamePlaceholder": "As per PAN",
  "auth.credentialsForm.lastNameLabel": "Last name",
  "auth.credentialsForm.lastNamePlaceholder": "As per PAN",
  "auth.credentialsForm.emailLabel": "Email ID",
  "auth.credentialsForm.emailPlaceholder": "Your email ID",
  "auth.credentialsForm.emailError": "Enter a valid email address",
  "auth.credentialsForm.mobileNumberLabel": "Mobile number",
  "auth.credentialsForm.mobileNumberHint": "We'll send a one-time code to this number",
  "auth.credentialsForm.phonePlaceholder": "98765 43210",
  "auth.credentialsForm.passwordLabel": "Password",
  "auth.credentialsForm.passwordPlaceholder": "Password",
  "auth.credentialsForm.passwordHint": "At least 8 characters, with upper, lower, a number and a symbol",
  "auth.credentialsForm.passwordError":
    "Password must be 8+ characters with an uppercase, lowercase, number and symbol",
  "auth.credentialsForm.confirmPasswordLabel": "Re-type Password",
  "auth.credentialsForm.confirmPasswordPlaceholder": "Re-type Password",
  "auth.credentialsForm.confirmPasswordError": "Passwords do not match",
  "auth.credentialsForm.firstNameError": "Enter a valid first name",
  "auth.credentialsForm.lastNameError": "Enter a valid last name",
  "auth.credentialsForm.roleLabel": "Application type",
  "auth.credentialsForm.rolePlaceholder": "Select application type",
  "auth.credentialsForm.roleBorrower": "Borrower",
  "auth.credentialsForm.roleLender": "Lender",
  "auth.credentialsForm.roleError": "Select an application type",
  "auth.credentialsForm.phoneError": "Enter a valid 10-digit mobile number",
  "auth.credentialsForm.consentLabelPrefix": "I agree to the",
  "auth.credentialsForm.consentLabelLink": "Terms & Conditions",
  "auth.credentialsForm.consentLabelAnd": "and",
  "auth.credentialsForm.consentLabelSuffix": "Privacy Policy",
  "auth.credentialsForm.consentViewRequiredHint": "Please review the Terms & Conditions to continue",
  "auth.credentialsForm.consentError": "You must agree to the Terms & Conditions and Privacy Policy",
  "auth.credentialsForm.duplicateAccountError": "This email or mobile number is already registered",
  "auth.credentialsForm.genericSubmitError": "Something went wrong — please try again",
  "auth.credentialsForm.submittingButton": "Sending...",
  "auth.credentialsForm.submitLabelDefault": "Verify",

  // --- auth / PasswordInput ---
  "auth.passwordInput.showPasswordLabel": "Show password",
  "auth.passwordInput.hidePasswordLabel": "Hide password",

  // --- auth / LoginForm ---
  "auth.loginForm.identifierLabel": "Email or Mobile Number",
  "auth.loginForm.identifierPlaceholder": "you@example.com or 98765 43210",
  "auth.loginForm.identifierError": "Enter a valid email address or 10-digit mobile number",
  "auth.loginForm.passwordLabel": "Password",
  "auth.loginForm.passwordPlaceholder": "Password",
  "auth.loginForm.passwordError": "Enter your password",
  "auth.loginForm.invalidCredentialsError": "Incorrect email/mobile number or password",
  "auth.loginForm.rateLimitedError": "Too many login attempts — please try again in a moment",
  "auth.loginForm.submittingButton": "Logging in...",
  "auth.loginForm.submitButton": "Log in",
  "auth.loginForm.forgotPasswordLink": "Forgot password?",

  // --- auth / OtpForm ---
  "auth.otpForm.codeSentMessageBoth": "Enter the 6-digit codes sent to +91 {phone} and {email}.",
  "auth.otpForm.editButton": "Edit",
  "auth.otpForm.phoneCodeLabel": "Phone code",
  "auth.otpForm.emailCodeLabel": "Email code",
  "auth.otpForm.codeExpiredHint": "Code expired",
  "auth.otpForm.validForHint": "Valid for {time}",
  "auth.otpForm.submittingButton": "Submitting...",
  "auth.otpForm.submitButton": "Submit",
  "auth.otpForm.resendingButton": "Resending...",
  "auth.otpForm.resendInSeconds": "Resend code in {seconds}s",
  "auth.otpForm.resendButton": "Resend code",
  "auth.otpForm.requiredCodeError": "Enter both 6-digit codes",
  "auth.otpForm.expiredCodeError": "These codes have expired — resend new ones",
  "auth.otpForm.incorrectCodeError": "Incorrect code — please try again",
  "auth.otpForm.sessionExpiredError": "Your session has expired — go back and sign up again",
  "auth.otpForm.tooManyAttemptsError": "Too many incorrect attempts — please sign up again",
  "auth.otpForm.genericError": "Something went wrong — please try again",

  // --- auth / ForgotPasswordForm ---
  "auth.forgotPasswordForm.requestHeading": "Reset your password",
  "auth.forgotPasswordForm.requestSubtitle":
    "Enter your registered email or mobile number and we'll send you a reset code.",
  "auth.forgotPasswordForm.identifierLabel": "Email or Mobile Number",
  "auth.forgotPasswordForm.identifierPlaceholder": "you@example.com or 98765 43210",
  "auth.forgotPasswordForm.identifierError": "Enter a valid email address or 10-digit mobile number",
  "auth.forgotPasswordForm.sendingButton": "Sending...",
  "auth.forgotPasswordForm.sendCodeButton": "Send reset code",
  "auth.forgotPasswordForm.backToLoginLink": "Back to login",
  "auth.forgotPasswordForm.resetHeading": "Enter the code",
  "auth.forgotPasswordForm.resetSubtitle": "We've sent a 6-digit code to {identifier}.",
  "auth.forgotPasswordForm.startOverLink": "Use a different email or number",
  "auth.forgotPasswordForm.codeLabel": "Verification code",
  "auth.forgotPasswordForm.requiredCodeError": "Enter the 6-digit code",
  "auth.forgotPasswordForm.newPasswordLabel": "New password",
  "auth.forgotPasswordForm.newPasswordPlaceholder": "New password",
  "auth.forgotPasswordForm.newPasswordHint": "At least 8 characters, with upper, lower, a number and a symbol",
  "auth.forgotPasswordForm.newPasswordError":
    "Password must be 8+ characters with an uppercase, lowercase, number and symbol",
  "auth.forgotPasswordForm.confirmPasswordLabel": "Re-type new password",
  "auth.forgotPasswordForm.confirmPasswordPlaceholder": "Re-type new password",
  "auth.forgotPasswordForm.confirmPasswordError": "Passwords do not match",
  "auth.forgotPasswordForm.resettingButton": "Resetting...",
  "auth.forgotPasswordForm.resetPasswordButton": "Reset password",
  "auth.forgotPasswordForm.invalidCodeError": "That code is incorrect — please check and try again",
  "auth.forgotPasswordForm.tooManyAttemptsError": "Too many incorrect attempts — please request a new code",
  "auth.forgotPasswordForm.genericError": "Something went wrong — please try again",

  // --- auth / AuthPage ---
  "auth.authPage.loginTab": "Log in",
  "auth.authPage.signupTab": "Sign up",
  "auth.authPage.welcomeBackHeading": "Welcome back",
  "auth.authPage.welcomeBackSubtitle": "Log in with your email or mobile number and password.",
  "auth.authPage.createAccountHeading": "Create your account",
  "auth.authPage.createAccountSubtitle": "A few details to get you started.",
  "auth.authPage.enterCodeHeading": "Enter the code",
  "auth.authPage.enterCodeSubtitleSignup":
    "Last step — verify your number to finish creating your account.",

  // --- lender / Sidebar ---
  "lender.sidebar.navDashboard": "Dashboard",
  "lender.sidebar.navReports": "Reports",
  "lender.sidebar.navProfile": "Profile",
  "lender.sidebar.navCreditor": "Creditor",
  "lender.sidebar.navOnboarding": "Onboarding",
  "lender.sidebar.navMembers": "Membership",
  "lender.sidebar.navSetup": "Enterprise Setup",
  "lender.sidebar.navJoinRequests": "Membership",
  "lender.sidebar.navPeople": "People",

  // --- lender / TopBar ---
  "lender.topBar.headingDashboard": "Dashboard",
  "lender.topBar.headingReports": "Reports",
  "lender.topBar.headingProfile": "Profile",
  "lender.topBar.headingCreditor": "Creditor",
  "lender.topBar.headingOnboarding": "Onboarding",
  "lender.topBar.headingMembers": "Membership",
  "lender.topBar.headingSetup": "Enterprise Setup",
  "lender.topBar.headingJoinRequests": "Membership",
  "lender.topBar.headingPeople": "People Directory",
  "lender.topBar.menuButtonLabel": "Toggle menu",
  "lender.topBar.accountMenuLabel": "Account menu",
  "lender.topBar.changePasswordMenuItem": "Change Password",
  "lender.topBar.profileMenuItem": "Profile",
  "lender.topBar.logoutMenuItem": "Logout",
  "lender.topBar.loggingOutMenuItem": "Logging out...",

  // --- lender / shared (BorrowerSearchBar, StatusFilterButton, WalletCard +
  // WalletBalanceBar, pagination controls — used across 2+ lender
  // sub-features) ---
  "lender.shared.statusFilterAll": "Status: All",
  "lender.shared.searchByBorrowerNamePlaceholder": "Search by borrower name",
  "lender.shared.searchButton": "Search",
  "lender.shared.walletBalanceTitle": "Lendcord Wallet Balance",
  "lender.shared.addFundsButton": "Add Funds",
  "lender.shared.previousPageLabel": "Previous page",
  "lender.shared.nextPageLabel": "Next page",
  "lender.shared.cancelButton": "Cancel",

  // --- lender / Members (admin-only role-upgrade request listing) ---
  "lender.members.heading": "Membership",
  "lender.members.columnUserId": "User ID",
  "lender.members.columnName": "Name",
  "lender.members.columnEmail": "Email",
  "lender.members.columnCurrentRole": "Current Role",
  "lender.members.columnTargetRole": "Target Role",
  "lender.members.columnStatus": "Status",
  "lender.members.columnRequestedAt": "Requested At",
  "lender.members.columnAction": "Action",
  "lender.members.statusIN_PROGRESS": "In Progress",
  "lender.members.statusAPPROVED": "Approved",
  "lender.members.statusREJECTED": "Rejected",
  "lender.members.actionApprove": "Approve",
  "lender.members.actionReject": "Reject",
  "lender.members.searchPlaceholder": "Search by name, ID, email, or phone",
  "lender.members.filtersButton": "Filters",
  "lender.members.filterAllStatuses": "All statuses",
  "lender.members.clearFiltersButton": "Clear filters",
  "lender.members.emptyStateMessage": "No membership requests yet.",
  "lender.members.noMatchingRequestsMessage": "No matching membership requests found.",
  "lender.members.approveDialogTitle": "Approve Role Upgrade",
  "lender.members.approveDialogDescription": "{user} ({id}) has requested to upgrade from their current role. Add remarks below.",
  "lender.members.approveRemarksPlaceholder": "Why are you approving this request?",
  "lender.members.rejectDialogTitle": "Reject Role Upgrade",
  "lender.members.rejectDialogDescription": "{user} ({id}) has requested a role upgrade. Add remarks below.",
  "lender.members.rejectRemarksPlaceholder": "Why are you rejecting this request?",
  "lender.members.actionView": "View profile",
  "lender.members.decisionError": "Failed to record this decision. Please try again.",
  "lender.members.profileDialogTitle": "{user} — Profile",
  "lender.members.profileDialogDescription": "{id} · {email} · {phone}",
  "lender.members.profileLoading": "Loading...",
  "lender.members.profileLoadError": "Failed to load profile.",
  "lender.members.profileFullNameLabel": "Full Name",

  // --- lender / People Directory (lendcord-core's PeopleDirectoryController) ---
  "lender.people.borrowerTotalLabel": "Borrowers",
  "lender.people.borrowerPendingLabel": "Borrowers Pending",
  "lender.people.borrowerApprovedLabel": "Borrowers Approved",
  "lender.people.lenderTotalLabel": "Lenders",
  "lender.people.lenderPendingLabel": "Lenders Pending",
  "lender.people.lenderApprovedLabel": "Lenders Approved",
  "lender.people.searchPlaceholder": "Search by name, ID, center, area...",
  "lender.people.filtersButton": "Filters",
  "lender.people.filterAllRoles": "All roles",
  "lender.people.filterAllStatuses": "All statuses",
  "lender.people.columnId": "User ID",
  "lender.people.columnName": "Name",
  "lender.people.columnRole": "Role",
  "lender.people.columnLoanAmount": "Loan Amount",
  "lender.people.columnStatus": "Status",
  "lender.people.columnCreatedAt": "Created",
  "lender.people.columnAction": "Action",
  "lender.people.viewAction": "View",
  "lender.people.emptyStateMessage": "No borrowers or lenders yet.",
  "lender.people.noMatchingMessage": "No matching people found.",
  "lender.people.loadError": "Couldn't load the people directory. Please try again.",
  "lender.people.detailLoadError": "Couldn't load this person's details. Please try again.",
  "lender.people.backToList": "Back to People Directory",
  "lender.people.identityHeading": "Identity",
  "lender.people.branchHeading": "Branch",
  "lender.people.branchLabel": "Branch",

  // --- lender / SetupPage (ENTERPRISE-only) ---
  "lender.setup.tabBranches": "Branches",
  "lender.setup.tabLoanPlans": "Loan Plans",
  "lender.setup.tabEnterpriseProfile": "Enterprise Profile",

  // --- lender / EnterpriseProfileTab (real backend — lendcord-core's EnterpriseBrandProfileController) ---
  "lender.enterpriseProfile.companyDetailsHeading": "Company Details",
  "lender.enterpriseProfile.legalNameLabel": "Legal Business Name",
  "lender.enterpriseProfile.legalNamePlaceholder": "e.g. Capicord Technologies Pvt. Ltd.",
  "lender.enterpriseProfile.displayNameLabel": "Display Name",
  "lender.enterpriseProfile.displayNamePlaceholder": "e.g. Lendcord",
  "lender.enterpriseProfile.registrationNumberLabel": "Registration / CIN Number",
  "lender.enterpriseProfile.gstinLabel": "GSTIN",
  "lender.enterpriseProfile.panLabel": "PAN",
  "lender.enterpriseProfile.websiteLabel": "Website",
  "lender.enterpriseProfile.contactEmailLabel": "Contact Email",
  "lender.enterpriseProfile.contactPhoneLabel": "Contact Phone",
  "lender.enterpriseProfile.addressLine1Label": "Address Line 1",
  "lender.enterpriseProfile.addressLine2Label": "Address Line 2",
  "lender.enterpriseProfile.cityLabel": "City",
  "lender.enterpriseProfile.stateLabel": "State",
  "lender.enterpriseProfile.pincodeLabel": "Pincode",
  "lender.enterpriseProfile.brandProfileHeading": "Brand Profile",
  "lender.enterpriseProfile.uploadLogoLabel": "Upload logo",
  "lender.enterpriseProfile.uploadLogoButton": "Upload Logo",
  "lender.enterpriseProfile.changeLogoButton": "Change Logo",
  "lender.enterpriseProfile.logoHint": "PNG or JPG, square image recommended.",
  "lender.enterpriseProfile.brandColorLabel": "Brand Color",
  "lender.enterpriseProfile.taglineLabel": "Tagline",
  "lender.enterpriseProfile.taglinePlaceholder": "e.g. Lending, simplified.",
  "lender.enterpriseProfile.aboutBrandLabel": "About",
  "lender.enterpriseProfile.aboutBrandPlaceholder": "A short description of your brand shown to borrowers and lenders.",
  "lender.enterpriseProfile.saveButton": "Save Changes",
  "lender.enterpriseProfile.savingButton": "Saving…",
  "lender.enterpriseProfile.saveSuccessTitle": "Enterprise profile saved",
  "lender.enterpriseProfile.saveError": "Couldn't save your enterprise profile. Please try again.",
  "lender.enterpriseProfile.loadError": "Couldn't load your enterprise profile. Please refresh and try again.",
  "lender.enterpriseProfile.uploadingLogoButton": "Uploading…",
  "lender.enterpriseProfile.logoUploadSuccessTitle": "Logo updated",
  "lender.enterpriseProfile.logoUploadErrorTitle": "Logo upload failed",
  "lender.enterpriseProfile.logoUploadError": "Couldn't upload your logo. Please try again.",
  "lender.enterpriseProfile.registrationNumberError": "Must be a valid CIN, e.g. U65999BR2020PTC012345",
  "lender.enterpriseProfile.gstinError": "Must be a valid GSTIN, e.g. 10ABCDE1234F1Z5",
  "lender.enterpriseProfile.panError": "Must be a valid PAN, e.g. ABCDE1234F",
  "lender.enterpriseProfile.contactPhoneError": "Must be a valid phone number",
  "lender.enterpriseProfile.pincodeError": "Must be a 6-digit pincode",
  "lender.enterpriseProfile.brandColorError": "Must be a 6-digit hex color, e.g. #0E6B5C",

  // --- lender / Branches (ENTERPRISE-only, real lendcord-core /branches API) ---
  "lender.branches.heading": "Branches",
  "lender.branches.searchPlaceholder": "Search by name, code, or ID",
  "lender.branches.columnId": "Branch ID",
  "lender.branches.columnName": "Name",
  "lender.branches.columnCode": "Code",
  "lender.branches.columnAddress": "Address",
  "lender.branches.columnCreatedAt": "Created",
  "lender.branches.columnAction": "Actions",
  "lender.branches.actionEdit": "Edit branch",
  "lender.branches.actionDelete": "Delete branch",
  "lender.branches.emptyStateMessage": "No branches yet. Add your first branch to get started.",
  "lender.branches.noMatchingBranchesMessage": "No branches match your search.",
  "lender.branches.addButton": "Add Branch",
  "lender.branches.addDialogTitle": "Add Branch",
  "lender.branches.editDialogTitle": "Edit Branch",
  "lender.branches.nameLabel": "Branch name",
  "lender.branches.namePlaceholder": "e.g. Patna Central",
  "lender.branches.nameError": "Enter a branch name",
  "lender.branches.codeLabel": "Code",
  "lender.branches.codePlaceholder": "e.g. PAT-01",
  "lender.branches.addressLabel": "Address",
  "lender.branches.addressPlaceholder": "e.g. 12 Fraser Road, Patna",
  "lender.branches.latitudeLabel": "Latitude",
  "lender.branches.latitudeError": "Enter a valid latitude (-90 to 90)",
  "lender.branches.longitudeLabel": "Longitude",
  "lender.branches.longitudeError": "Enter a valid longitude (-180 to 180)",
  "lender.branches.saveButton": "Save changes",
  "lender.branches.savingButton": "Saving…",
  "lender.branches.saveError": "Couldn't save this branch. Please try again.",
  "lender.branches.deleteDialogTitle": "Delete branch?",
  "lender.branches.deleteDialogDescription": "Are you sure you want to delete \"{name}\"? This can't be undone.",
  "lender.branches.deleteButton": "Delete",
  "lender.branches.deletingButton": "Deleting…",
  "lender.branches.deleteError": "Couldn't delete this branch. Please try again.",

  // --- lender / LoanSchemes (ENTERPRISE-only, real lendcord-core /enterprise/loan-schemes API) ---
  "lender.loanSchemes.heading": "Loan Plans",
  "lender.loanSchemes.searchPlaceholder": "Search by code or name",
  "lender.loanSchemes.columnSchemeCode": "Scheme Code",
  "lender.loanSchemes.columnName": "Name",
  "lender.loanSchemes.columnLoanRange": "Loan Amount",
  "lender.loanSchemes.columnInterestRate": "Interest Rate",
  "lender.loanSchemes.columnEmiType": "EMI Type",
  "lender.loanSchemes.columnStatus": "Status",
  "lender.loanSchemes.columnAction": "Actions",
  "lender.loanSchemes.actionEdit": "Edit scheme",
  "lender.loanSchemes.statusActive": "Active",
  "lender.loanSchemes.statusInactive": "Inactive",
  "lender.loanSchemes.emptyStateMessage": "No loan plans yet. Add your first scheme to get started.",
  "lender.loanSchemes.noMatchingSchemesMessage": "No loan plans match your search.",
  "lender.loanSchemes.addButton": "Add Loan Plan",
  "lender.loanSchemes.addDialogTitle": "Add Loan Plan",
  "lender.loanSchemes.editDialogTitle": "Edit Loan Plan",
  "lender.loanSchemes.schemeCodeLabel": "Scheme code",
  "lender.loanSchemes.schemeCodeError": "Enter a scheme code",
  "lender.loanSchemes.nameLabel": "Scheme name",
  "lender.loanSchemes.nameError": "Enter a scheme name",
  "lender.loanSchemes.minLoanAmountLabel": "Minimum loan amount",
  "lender.loanSchemes.minMaxError": "Minimum amount can't exceed the maximum",
  "lender.loanSchemes.maxLoanAmountLabel": "Maximum loan amount",
  "lender.loanSchemes.maxLoanAmountError": "Enter a valid maximum loan amount",
  "lender.loanSchemes.annualInterestRateLabel": "Annual interest rate (%)",
  "lender.loanSchemes.annualInterestRateError": "Enter a valid interest rate",
  "lender.loanSchemes.emiTypeLabel": "EMI type",
  "lender.loanSchemes.emiTypePlaceholder": "Select EMI type",
  "lender.loanSchemes.emiTypeError": "Select an EMI type",
  "lender.loanSchemes.emiTypeFlat": "Flat",
  "lender.loanSchemes.emiTypeReducingBalance": "Reducing Balance",
  "lender.loanSchemes.chargesHeading": "Charges",
  "lender.loanSchemes.preClosureChargeLabel": "Pre-closure charge",
  "lender.loanSchemes.processingFeeLabel": "Processing fee",
  "lender.loanSchemes.collectionChargeLabel": "Collection charge",
  "lender.loanSchemes.stampDutyChargeLabel": "Stamp duty charge",
  "lender.loanSchemes.otherEmiChargeLabel": "Other EMI charge",
  "lender.loanSchemes.chargeTypeNotCharged": "Not charged",
  "lender.loanSchemes.chargeTypeFlat": "Flat Amount",
  "lender.loanSchemes.chargeTypePercentage": "Percentage",
  "lender.loanSchemes.chargeValueLabel": "Value",
  "lender.loanSchemes.chargeValueError": "Enter a value for this charge",
  "lender.loanSchemes.collectorCommissionRateLabel": "Collector commission rate (%)",
  "lender.loanSchemes.firstEmiDeductLabel": "Deduct first EMI on disbursement",
  "lender.loanSchemes.activeLabel": "Active",
  "lender.loanSchemes.penaltyHeading": "Late-payment penalty",
  "lender.loanSchemes.penaltyTypeLabel": "Penalty type",
  "lender.loanSchemes.penaltyTypePlaceholder": "Select penalty type",
  "lender.loanSchemes.penaltyTypeError": "Select a penalty type",
  "lender.loanSchemes.penaltyTypeFixed": "Fixed",
  "lender.loanSchemes.penaltyTypeIncreasing": "Increasing",
  "lender.loanSchemes.ruleHeading": "Rule {position}",
  "lender.loanSchemes.removeRuleLabel": "Remove rule",
  "lender.loanSchemes.addRuleButton": "+ Add Penalty Rule",
  "lender.loanSchemes.fromDaysLabel": "From day",
  "lender.loanSchemes.ruleFromDaysError": "Enter a valid starting day",
  "lender.loanSchemes.toDaysLabel": "To day",
  "lender.loanSchemes.ruleToDaysError": "Enter a valid ending day",
  "lender.loanSchemes.calculationTypeLabel": "Calculation type",
  "lender.loanSchemes.calculationTypePlaceholder": "Select calculation type",
  "lender.loanSchemes.ruleCalculationTypeError": "Select a calculation type",
  "lender.loanSchemes.calculationTypeFlatAmount": "Flat Amount",
  "lender.loanSchemes.calculationTypePercentOfOverdueEmi": "% of Overdue EMI",
  "lender.loanSchemes.parameterLabel": "Amount / percentage",
  "lender.loanSchemes.ruleParameterError": "Enter a valid amount",
  "lender.loanSchemes.remarksLabel": "Remarks",
  "lender.loanSchemes.saveButton": "Save changes",
  "lender.loanSchemes.savingButton": "Saving…",
  "lender.loanSchemes.saveError": "Couldn't save this loan plan. Please try again.",

  // --- lender / JoinRequests (ENTERPRISE-only, real lendcord-core /enterprise/join-requests API) ---
  "lender.joinRequests.heading": "Membership",
  "lender.joinRequests.searchPlaceholder": "Search by name, ID, email, or phone",
  "lender.joinRequests.columnUserId": "User ID",
  "lender.joinRequests.columnName": "Name",
  "lender.joinRequests.columnEmail": "Email",
  "lender.joinRequests.columnRole": "Role",
  "lender.joinRequests.columnStatus": "Status",
  "lender.joinRequests.columnRequestedAt": "Requested",
  "lender.joinRequests.columnAction": "Actions",
  "lender.joinRequests.statusIN_PROGRESS": "In Progress",
  "lender.joinRequests.statusAPPROVED": "Approved",
  "lender.joinRequests.statusREJECTED": "Rejected",
  "lender.joinRequests.filtersButton": "Filters",
  "lender.joinRequests.filterAllStatuses": "All statuses",
  "lender.joinRequests.clearFiltersButton": "Clear filters",
  "lender.joinRequests.emptyStateMessage": "No membership requests yet.",
  "lender.joinRequests.noMatchingRequestsMessage": "No matching membership requests found.",
  "lender.joinRequests.actionView": "View profile",
  "lender.joinRequests.actionApprove": "Approve",
  "lender.joinRequests.actionReject": "Reject",
  "lender.joinRequests.approveDialogTitle": "Approve Join Request",
  "lender.joinRequests.approveDialogDescription": "{user} ({id}) has requested to join your enterprise. Add remarks below.",
  "lender.joinRequests.approveRemarksPlaceholder": "Add a note for your records",
  "lender.joinRequests.rejectDialogTitle": "Reject Join Request",
  "lender.joinRequests.rejectDialogDescription": "{user} ({id}) has requested to join your enterprise. Add remarks below.",
  "lender.joinRequests.rejectRemarksPlaceholder": "Why are you rejecting this request?",
  "lender.joinRequests.branchLabel": "Branch",
  "lender.joinRequests.branchPlaceholder": "Select a branch",
  "lender.joinRequests.noBranchesError": "You don't have any branches yet — create one under Setup before approving a request.",
  "lender.joinRequests.decisionError": "Failed to record this decision. Please try again.",
  "lender.joinRequests.profileDialogTitle": "{user} — Profile",
  "lender.joinRequests.profileDialogDescription": "{id} · {email} · {phone}",
  "lender.joinRequests.profileLoading": "Loading...",
  "lender.joinRequests.profileLoadError": "Failed to load profile.",

  // --- lender / WalletCard ---
  "lender.walletCard.availableToWithdrawLabel": "Available to withdraw",

  // --- lender / PortfolioSection ---
  "lender.portfolioSection.heading": "Your Lendcord Portfolio",
  "lender.portfolioSection.totalFundsAddedLabel": "Total Funds Added",
  "lender.portfolioSection.interestEarnedLabel": "Interest Earned",
  "lender.portfolioSection.netAssetValueLabel": "Net Asset Value",
  "lender.portfolioSection.withdrawnLabel": "Withdrawn {amount}",


  // --- lender / SupportCard ---
  "lender.supportCard.title": "How can we help you?",
  "lender.supportCard.description": "Reach out to our support team any time.",
  "lender.supportCard.phoneLabel": "Call us at: {phone}",
  "lender.supportCard.callBackButton": "Request a call back",

  // --- lender / Reports ---
  "lender.reports.generateButton": "Generate",

  // --- lender / Profile ---
  "lender.profile.statusActive": "Active",
  "lender.profile.verifiedBadge": "Verified",
  "lender.profile.unverifiedBadge": "Unverified",
  "lender.profile.primaryBadge": "Primary",
  "lender.profile.lenderIdLabel": "Lender ID",
  "lender.profile.panLabel": "PAN",
  "lender.profile.aadhaarLabel": "Aadhaar",
  "lender.profile.phoneLabel": "Phone",
  "lender.profile.emailLabel": "Email",
  "lender.profile.upgradeToCreditorButton": "Upgrade to Creditor",
  "lender.profile.upgradeToCreditorConfirmHeading": "Upgrade to Creditor?",
  "lender.profile.upgradeToCreditorConfirmDescription": "Creditor (enterprise) accounts get access to bulk lending, investor dashboards, and higher disbursement limits. We'll review your request and get back to you.",
  "lender.profile.upgradeToCreditorCancelButton": "Cancel",
  "lender.profile.upgradeToCreditorConfirmButton": "Request Upgrade",
  "lender.profile.upgradeToCreditorRequestingButton": "Requesting...",
  "lender.profile.upgradeToCreditorApproved": "Your upgrade to Creditor has been approved. Please log out and back in to access your new features.",
  "lender.profile.upgradeToCreditorRejected": "Your upgrade request was declined. Reason: {remarks}",
  "lender.profile.upgradeToCreditorRejectedNoRemarks": "no reason provided",
  "lender.profile.upgradeToCreditorInProgress": "Your upgrade request is being reviewed. We'll notify you once a decision is made.",
  "lender.profile.upgradeError": "Could not submit your upgrade request. Please try again.",

  // --- lender / ProfileIdentityCard (Join Enterprise) ---
  "lender.profile.joinEnterpriseButton": "Join an Enterprise",
  "lender.profile.joinEnterpriseDialogTitle": "Join an Enterprise",
  "lender.profile.joinEnterpriseDialogDescription": "Send a request to join an enterprise. They'll review your profile and, if approved, you'll move to one of their branches.",
  "lender.profile.joinEnterprisePickerLabel": "Enterprise",
  "lender.profile.joinEnterprisePickerPlaceholder": "Select an enterprise",
  "lender.profile.joinEnterpriseLoadingPlaceholder": "Loading enterprises…",
  "lender.profile.joinEnterpriseNoneAvailable": "No enterprises are available to join right now.",
  "lender.profile.joinEnterpriseSendButton": "Send Request",
  "lender.profile.joinEnterpriseSendingButton": "Sending…",
  "lender.profile.joinEnterpriseApproved": "You've joined {enterprise}. Please log out and back in to see your updated branch.",
  "lender.profile.joinEnterpriseRejected": "Your request to join {enterprise} was declined. Reason: {remarks}",
  "lender.profile.joinEnterpriseRejectedNoRemarks": "no reason provided",
  "lender.profile.joinEnterpriseInProgress": "Your request to join {enterprise} is being reviewed. We'll notify you once a decision is made.",
  "lender.profile.joinEnterpriseError": "Could not submit your join request. Please try again.",

  "lender.profile.deleteAccountButton": "Delete Account",
  "lender.profile.deletingAccountButton": "Deleting...",
  "lender.profile.deleteAccountCancelButton": "Cancel",
  "lender.profile.deleteAccountConfirmHeading": "Delete your account?",
  "lender.profile.deleteAccountConfirmDescription": "This deactivates your account and signs you out everywhere. This can't be undone from here — contact support if you change your mind.",
  "lender.profile.deleteAccountError": "Failed to delete your account. Please try again.",
  "lender.profile.kycDetailsHeading": "KYC Details",
  "lender.profile.tabKyc": "KYC",
  "lender.profile.tabAddresses": "Addresses",
  "lender.profile.tabDocuments": "Documents",
  "lender.profile.tabBankAccount": "Bank Account",
  "lender.profile.tabEmploymentDetails": "Employment Details",
  "lender.profile.fathersNameLabel": "Father's Name",
  "lender.profile.dateOfBirthLabel": "Date of Birth",
  "lender.profile.genderLabel": "Gender",
  "lender.profile.genderPlaceholder": "Select gender",
  "lender.profile.genderMale": "Male",
  "lender.profile.genderFemale": "Female",
  "lender.profile.genderOther": "Other",
  "lender.profile.loanAmountLabel": "Loan Amount",
  "lender.profile.fathersNameFormatError": "Enter a valid name",
  "lender.profile.nomineeContactFormatError": "Enter a valid 10-digit mobile number",
  "lender.profile.nomineeDetailsHeading": "Nominee Details",
  "lender.profile.removeNomineeButton": "Remove",
  "lender.profile.removingNomineeButton": "Removing...",
  "lender.profile.removeNomineeConfirmHeading": "Remove nominee?",
  "lender.profile.removeNomineeConfirmDescription": "This deletes your nominee's details from your profile. You can add a new nominee again at any time.",
  "lender.profile.removeNomineeError": "Failed to remove nominee. Please try again.",
  "lender.profile.nomineeNameLabel": "Name",
  "lender.profile.nomineeContactNumberLabel": "Contact Number",
  "lender.profile.nomineeRelationshipLabel": "Relationship",
  "lender.profile.relationshipPlaceholder": "Select relationship",
  "lender.profile.relationshipSpouse": "Spouse",
  "lender.profile.relationshipParent": "Parent",
  "lender.profile.relationshipChild": "Child",
  "lender.profile.relationshipSibling": "Sibling",
  "lender.profile.relationshipOther": "Other",
  "lender.profile.nomineeNameRequiredError": "Nominee name is required",
  "lender.profile.nomineeRelationshipRequiredError": "Select the nominee's relationship",
  "lender.profile.addressesHeading": "Addresses",
  "lender.profile.noAddressMessage": "No address added yet",
  "lender.profile.addressTypeCurrent": "Current",
  "lender.profile.addressTypePermanent": "Permanent",
  "lender.profile.addressTypeOffice": "Office",
  "lender.profile.addressLine1Label": "Address Line 1",
  "lender.profile.addressLine2Label": "Address Line 2 (optional)",
  "lender.profile.addressCityLabel": "City",
  "lender.profile.addressStateLabel": "State",
  "lender.profile.addressPincodeLabel": "Pincode",
  "lender.profile.addressLine1RequiredError": "Address line 1 is required",
  "lender.profile.addressCityRequiredError": "City is required",
  "lender.profile.addressStateRequiredError": "State is required",
  "lender.profile.addressPincodeFormatError": "Enter a valid 6-digit pincode",
  "lender.profile.addressUpdateError": "Couldn't save this address. Please try again.",
  "lender.profile.uploadDocumentsHeading": "Upload Documents",
  "lender.profile.uploadedOnLabel": "Uploaded on : {timestamp}",
  "lender.profile.downloadDocumentButton": "Download",
  "lender.profile.uploadAgainButton": "Upload Again",
  "lender.profile.uploadButton": "Upload",
  "lender.profile.uploadingButton": "Uploading…",
  "lender.profile.revealErrorTitle": "Couldn't reveal value",
  "lender.profile.revealError": "Couldn't reveal this value. Please try again.",
  "lender.profile.revealPanLabel": "Reveal PAN",
  "lender.profile.hidePanLabel": "Hide PAN",
  "lender.profile.revealAadhaarLabel": "Reveal Aadhaar",
  "lender.profile.hideAadhaarLabel": "Hide Aadhaar",
  "lender.profile.uploadPhotoLabel": "Upload profile photo",
  "lender.profile.editPhotoLabel": "Edit",
  "lender.profile.documentUploadError": "Couldn't upload this document. Please try again.",
  "lender.profile.documentUploadTooSmall": "File is too small. Minimum size is 50 KB.",
  "lender.profile.documentUploadTooLarge": "File is too large. Maximum size is 1 MB for images and 2 MB for PDFs.",
  "lender.profile.documentMenuLabel": "Document options",
  "lender.profile.documentTypeAadhaarFront": "Aadhaar (Front)",
  "lender.profile.documentTypeAadhaarBack": "Aadhaar (Back)",
  "lender.profile.documentTypePan": "PAN",
  "lender.profile.documentTypePhoto": "Photo",
  "lender.profile.documentTypeAddressProof": "Address Proof",
  "lender.profile.documentTypeIdProof": "ID Proof",
  "lender.profile.documentTypeBankAccount": "Bank Account Proof",
  "lender.profile.documentTypeOther": "Other",
  "lender.profile.documentUploadAadhaarFront": "AADHAAR FRONT",
  "lender.profile.documentUploadAadhaarBack": "AADHAAR BACK",
  "lender.profile.documentUploadAadhaarFrontButton": "Upload Front",
  "lender.profile.documentUploadAadhaarBackButton": "Upload Back",
  "lender.profile.documentStatusPending": "Pending",
  "lender.profile.documentStatusApproved": "Approved",
  "lender.profile.documentStatusRejected": "Rejected",
  "lender.profile.bankAccountDetailsHeading": "Bank Account Details",
  "lender.profile.noBankDetailsMessage": "No bank details on file yet",
  "lender.profile.bankNameLabel": "Bank Name",
  "lender.profile.accountTypeLabel": "Account Type",
  "lender.profile.accountNumberLabel": "Account Number",
  "lender.profile.ifscCodeLabel": "IFSC Code",
  "lender.profile.accountHolderNameLabel": "Account Holder Name",
  "lender.profile.accountNumberEditHint": "Re-enter your full account number to update it",
  "lender.profile.accountTypePlaceholder": "Select account type",
  "lender.profile.accountTypeSavings": "Savings",
  "lender.profile.accountTypeCurrent": "Current",
  "lender.profile.accountNumberFormatError": "Enter a valid account number (9–18 digits)",
  "lender.profile.ifscFormatError": "Enter a valid IFSC code",
  "lender.profile.accountHolderNameRequiredError": "Account holder name is required",
  "lender.profile.bankNameRequiredError": "Bank name is required",
  "lender.profile.accountTypeRequiredError": "Select an account type",
  "lender.profile.bankUpdateError": "Couldn't save your bank details. Please try again.",
  "lender.profile.employmentDetailsHeading": "Employment Details",
  "lender.profile.removeEmploymentButton": "Remove",
  "lender.profile.removingEmploymentButton": "Removing...",
  "lender.profile.removeEmploymentConfirmHeading": "Remove employment details?",
  "lender.profile.removeEmploymentConfirmDescription": "This deletes your employment details from your profile. You can add them again at any time.",
  "lender.profile.removeEmploymentError": "Failed to remove employment details. Please try again.",
  "lender.profile.employmentTypeLabel": "Employment Type",
  "lender.profile.employmentTypePlaceholder": "Select employment type",
  "lender.profile.employmentTypeSalaried": "Salaried",
  "lender.profile.employmentTypeSelfEmployed": "Self-Employed",
  "lender.profile.employmentTypeBusiness": "Business",
  "lender.profile.employmentTypeUnemployed": "Unemployed",
  "lender.profile.employmentTypeRetired": "Retired",
  "lender.profile.employmentTypeStudent": "Student",
  "lender.profile.employmentTypeOther": "Other",
  "lender.profile.employerNameLabel": "Employer Name",
  "lender.profile.designationLabel": "Designation",
  "lender.profile.highestQualificationLabel": "Highest Qualification",
  "lender.profile.monthlyIncomeLabel": "Monthly Income",
  "lender.profile.monthlyIncomeFormatError": "Enter a valid amount",
  "lender.profile.employmentTypeRequiredError": "Select an employment type",
  "lender.profile.employmentUpdateError": "Couldn't save your employment details. Please try again.",
  "lender.profile.noEmploymentMessage": "No employment details on file yet",
  "lender.profile.editButton": "Edit",
  "lender.profile.addButton": "Add",
  "lender.profile.saveButton": "Save",
  "lender.profile.savingButton": "Saving…",
  "lender.profile.cancelButton": "Cancel",
  "lender.profile.panPlaceholder": "ABCDE1234F",
  "lender.profile.aadhaarPlaceholder": "123456789012",
  "lender.profile.panEditHint": "Leave blank to keep your current PAN",
  "lender.profile.aadhaarEditHint": "Leave blank to keep your current Aadhaar",
  "lender.profile.panFormatError": "Enter a valid PAN (e.g. ABCDE1234F)",
  "lender.profile.aadhaarFormatError": "Enter a valid 12-digit Aadhaar number",
  "lender.profile.dobFutureError": "Date of birth must be in the past",
  "lender.profile.dobMinAgeError": "Age must be greater than 18 years",
  "lender.profile.panTakenError": "This PAN is already registered to a different account",
  "lender.profile.aadhaarTakenError": "This Aadhaar is already registered to a different account",
  "lender.profile.identityUpdateError": "Couldn't save your details. Please try again.",

  // --- lender / ChangePasswordDialog ---
  "lender.changePasswordDialog.heading": "Change Password",
  "lender.changePasswordDialog.oldPasswordLabel": "Old Password",
  "lender.changePasswordDialog.oldPasswordPlaceholder": "Old Password",
  "lender.changePasswordDialog.oldPasswordError": "Enter your current password",
  "lender.changePasswordDialog.newPasswordLabel": "New Password",
  "lender.changePasswordDialog.newPasswordPlaceholder": "New Password",
  "lender.changePasswordDialog.newPasswordHint": "At least 8 characters, with upper, lower, a number and a symbol",
  "lender.changePasswordDialog.newPasswordError":
    "Password must be 8+ characters with an uppercase, lowercase, number and symbol",
  "lender.changePasswordDialog.confirmPasswordLabel": "Confirm Password",
  "lender.changePasswordDialog.confirmPasswordPlaceholder": "Confirm Password",
  "lender.changePasswordDialog.confirmPasswordError": "Passwords do not match",
  "lender.changePasswordDialog.submitButton": "Change Password",
  "lender.changePasswordDialog.submittingButton": "Changing…",
  "lender.changePasswordDialog.wrongOldPasswordError": "Your current password is incorrect",
  "lender.changePasswordDialog.genericError": "Couldn't change your password. Please try again.",

  // --- auth / ForcePasswordChangePage ---
  "auth.forcePasswordChange.heading": "Set a new password",
  "auth.forcePasswordChange.subtitle":
    "Your account was created with a temporary password. Set a new one to continue to Lendcord.",
  "auth.forcePasswordChange.infoBanner":
    "This is a one-time step — you won't be asked again after this.",
  "auth.forcePasswordChange.temporaryPasswordLabel": "Temporary password",
  "auth.forcePasswordChange.temporaryPasswordPlaceholder": "The password you were given",
  "auth.forcePasswordChange.temporaryPasswordError": "Enter the temporary password you were given",
  "auth.forcePasswordChange.newPasswordLabel": "New password",
  "auth.forcePasswordChange.newPasswordPlaceholder": "New password",
  "auth.forcePasswordChange.newPasswordHint": "At least 8 characters, with upper, lower, a number and a symbol",
  "auth.forcePasswordChange.newPasswordError":
    "Password must be 8+ characters with an uppercase, lowercase, number and symbol",
  "auth.forcePasswordChange.confirmPasswordLabel": "Confirm new password",
  "auth.forcePasswordChange.confirmPasswordPlaceholder": "Confirm new password",
  "auth.forcePasswordChange.confirmPasswordError": "Passwords do not match",
  "auth.forcePasswordChange.submitButton": "Set new password & continue",
  "auth.forcePasswordChange.submittingButton": "Setting password…",
  "auth.forcePasswordChange.wrongTemporaryPasswordError": "That temporary password isn't correct",
  "auth.forcePasswordChange.genericError": "Couldn't set your new password. Please try again.",
  "auth.forcePasswordChange.logoutLink": "Not you? Log out",

  // --- lender / Creditor ---
  "lender.creditor.overviewHeading": "Overview",
  "lender.creditor.addBorrowerButton": "+ Borrower",
  "lender.creditor.emiDashboardButton": "EMI Dashboard",
  "lender.creditor.viewListLink": "View List",
  "lender.creditor.totalLoanAmountLabel": "Total Loan Amount Disbursed",
  "lender.creditor.totalBorrowersLabel": "Total Borrowers",
  "lender.creditor.totalInvestorsLabel": "Total Investors",
  "lender.creditor.walletBalanceLabel": "Wallet Balance",
  "lender.creditor.principalOutstandingLabel": "Principal Outstanding",
  "lender.creditor.currentMonthEmiDueLabel": "Current Month EMI Due",
  "lender.creditor.allInvestorsHeading": "All Investors",
  "lender.creditor.backToOverviewLabel": "Back to overview",
  "lender.creditor.searchInvestorsPlaceholder": "Search investors...",
  "lender.creditor.columnInvestorId": "Investor ID",
  "lender.creditor.columnInvestorName": "Investor Name",
  "lender.creditor.columnLoansOutstanding": "Loans Outstanding",
  "lender.creditor.columnInterestEarned": "Interest Earned",
  "lender.creditor.columnWalletBalance": "Wallet Balance",
  "lender.creditor.columnAction": "Action",
  "lender.creditor.rowsPerPageLabel": "Rows per page: {count}",
  "lender.creditor.paginationRangeLabel": "{start}-{end} of {total}",
  "lender.creditor.emiDashboardHeading": "EMI Dashboard",
  "lender.creditor.periodThisMonth": "This Month",
  "lender.creditor.totalEmiCollectedLabel": "Total EMI Collected",
  "lender.creditor.emisDueTodayLabel": "EMIs Due Today",
  "lender.creditor.overdueAmountLabel": "Overdue Amount",
  "lender.creditor.activeLoansLabel": "Active Loans",
  "lender.creditor.recoveryRateLabel": "Recovery Rate",
  "lender.creditor.statusTabAll": "All",
  "lender.creditor.statusTabUpcoming": "Upcoming",
  "lender.creditor.statusTabOverdue": "Overdue",
  "lender.creditor.statusTabPaid": "Paid",
  "lender.creditor.searchLoanPlaceholder": "Search by loan ID or borrower",
  "lender.creditor.downloadDataButton": "Download Data",
  "lender.creditor.columnLoanId": "Loan ID",
  "lender.creditor.columnBorrower": "Borrower",
  "lender.creditor.columnEmiAmount": "EMI Amt",
  "lender.creditor.columnDueDate": "Due Date",
  "lender.creditor.columnPaidDate": "Paid Date",
  "lender.creditor.columnStatus": "Status",
  "lender.creditor.columnPrincipal": "Principal",
  "lender.creditor.columnInterest": "Interest",
  "lender.creditor.columnOutstanding": "Outstanding",
  "lender.creditor.columnTenure": "Tenure",
  "lender.creditor.columnMode": "Mode",
  "lender.creditor.actionViewLink": "View",
  "lender.creditor.noMatchingRecordsMessage": "No matching records",
  "lender.creditor.borrowerListHeading": "Borrower",
  "lender.creditor.filterAllLabel": "ALL",
  "lender.creditor.addNewBorrowerButton": "+ Add New Borrower",
  "lender.creditor.searchBorrowersPlaceholder": "Search borrowers...",
  "lender.creditor.columnBorrowerId": "Borrower ID",
  "lender.creditor.columnBorrowerName": "Borrower Name",
  "lender.creditor.columnLoanAmount": "Loan Amount",
  "lender.creditor.columnTotalRepaid": "Total Repaid",
  "lender.creditor.columnTotalDue": "Total Due",
  "lender.creditor.columnRegistrationStatus": "Registration Status",
  "lender.creditor.columnRegistrationContactNumber": "Registration Contact Number",
  "lender.creditor.columnLoanStatus": "Loan Status",
  "lender.creditor.registrationActionContinue": "Continue",
  "lender.creditor.registrationActionVerifyMobile": "Verify Mobile",
  "lender.creditor.loanStatusApproved": "Approved",
  "lender.creditor.loanStatusPending": "Pending",
  "lender.creditor.loanStatusCommitted": "Committed",

  // --- lender / Onboarding ---
  "lender.onboarding.pageTitle": "New Application",
  "lender.onboarding.pageDescription": "Verify the borrower's identity and submit an onboarding application.",
  "lender.onboarding.viewPageTitle": "Application Details",
  "lender.onboarding.detailLoadError": "Failed to load application details. Please try again.",
  "lender.onboarding.locationHeading": "Location",
  "lender.onboarding.additionalDetailsHeading": "Additional Details",
  "lender.onboarding.centerNameLabel": "Center Name",
  "lender.onboarding.areaLabel": "Area",
  "lender.onboarding.createdAtMeta": "Submitted on {date}",
  "lender.onboarding.targetEmailLabel": "Email",
  "lender.onboarding.targetPhoneLabel": "Phone",
  "lender.onboarding.emailFormatError": "Enter a valid email address",
  "lender.onboarding.phoneFormatError": "Enter a valid 10-digit phone number",
  "lender.onboarding.applicationTypeLender": "Lender",
  "lender.onboarding.firstNameLabel": "First Name",
  "lender.onboarding.middleNameLabel": "Middle Name",
  "lender.onboarding.lastNameLabel": "Last Name",
  "lender.onboarding.firstNameRequiredError": "First name is required",
  "lender.onboarding.generatedCredentialsHeading": "Generated Credentials",
  "lender.onboarding.generatedReadableId": "User ID: {id}",
  "lender.onboarding.generatedPassword": "Password: {password}",
  "lender.onboarding.applicationTypeHeading": "Application Type",
  "lender.onboarding.applicationTypeLabel": "Application Type",
  "lender.onboarding.applicationTypePlaceholder": "Select application type",
  "lender.onboarding.applicationTypeBorrower": "Borrower",
  "lender.onboarding.applicationTypeStaff": "Staff",
  "lender.onboarding.applicationTypeAgent": "Agent",
  "lender.onboarding.applicationTypeRequiredError": "Application type is required",
  "lender.onboarding.branchHeading": "Branch",
  "lender.onboarding.branchLabel": "Branch",
  "lender.onboarding.branchPlaceholder": "Select branch",
  "lender.onboarding.branchLoadingPlaceholder": "Loading branches...",
  "lender.onboarding.branchRequiredError": "Branch is required",
  "lender.onboarding.noBranchesMessage": "No branches have been created yet. Ask your administrator to create a branch before onboarding staff or agents.",
  "lender.onboarding.personalDetailsHeading": "Personal Details",
  "lender.onboarding.addressHeading": "Address",
  "lender.onboarding.addressStateLabel": "State",
  "lender.onboarding.addressStatePlaceholder": "Select state",
  "lender.onboarding.addressDistrictLabel": "District",
  "lender.onboarding.addressDistrictPlaceholder": "Select district",
  "lender.onboarding.addressDistrictRequiredError": "District is required",
  "lender.onboarding.addressLine1RequiredError": "Address is required",
  "lender.onboarding.aadhaarRequiredError": "Aadhaar number is required",
  "lender.onboarding.dobRequiredError": "Date of birth is required",
  "lender.onboarding.loanDetailsHeading": "Loan Details",
  "lender.onboarding.loanAmountLabel": "Loan Amount (₹)",
  "lender.onboarding.loanAmountRequiredError": "Loan amount is required and must be greater than zero",
  "lender.onboarding.latitudeLabel": "Latitude",
  "lender.onboarding.longitudeLabel": "Longitude",
  "lender.onboarding.latitudeRequiredError": "Latitude is required. Use 'Get Current Location' to fill it in.",
  "lender.onboarding.longitudeRequiredError": "Longitude is required. Use 'Get Current Location' to fill it in.",

  "lender.onboarding.coordinatesLabel": "Coordinates",

  "lender.onboarding.getCurrentLocationButton": "Get Current Location",
  "lender.onboarding.geoLocationError": "Unable to get current location. Check location permissions and try again.",
  "lender.onboarding.submitButton": "Submit Application",
  "lender.onboarding.submittingButton": "Submitting...",
  "lender.onboarding.submitSuccess": "Application submitted successfully!",
  "lender.onboarding.submitError": "Failed to submit application. Please try again.",

  "lender.onboarding.documentHeading": "Documents",
  "lender.onboarding.documentPanLabel": "PAN Card",
  "lender.onboarding.documentAadhaarFrontLabel": "Aadhaar (Front)",
  "lender.onboarding.documentAadhaarBackLabel": "Aadhaar (Back)",
  "lender.onboarding.documentUploadButton": "Upload",
  "lender.onboarding.documentUploaded": "Uploaded",
  "lender.onboarding.documentRemove": "Remove",
  "lender.onboarding.additionalDocumentsHeading": "Additional Documents",
  "lender.onboarding.additionalDocumentLabel": "Document {id}",
  "lender.onboarding.addDocumentButton": "Add Document",

  // --- lender / Onboarding / Applications List ---
  "lender.onboarding.applicationsListHeading": "Applications",
  "lender.onboarding.emptyStateMessage": "No applications yet. Click \"Add New Customer\" to onboard your first one.",
  "lender.onboarding.noMatchingApplicationsMessage": "No applications match the selected filters.",
  "lender.onboarding.addNewCustomerButton": "+ Add New Customer",
  "lender.onboarding.searchApplicationsPlaceholder": "Search applications...",
  "lender.onboarding.columnFullName": "Name",
  "lender.onboarding.columnReadableId": "ID",
  "lender.onboarding.columnApplicationType": "Type",
  "lender.onboarding.columnLoanAmount": "Loan Amount",
  "lender.onboarding.columnStatus": "Status",
  "lender.onboarding.columnAction": "Action",
  "lender.onboarding.actionViewLink": "View",
  "lender.onboarding.actionEditLink": "Edit",
  "lender.onboarding.columnLocation": "Location",
  "lender.onboarding.columnCreatedAt": "Created At",
  "lender.onboarding.columnRemarks": "Remarks",
  "lender.onboarding.statusPENDING": "Pending",
  "lender.onboarding.statusIN_PROGRESS": "In Progress",
  "lender.onboarding.statusAPPROVED": "Approved",
  "lender.onboarding.statusREJECTED": "Rejected",
  "lender.onboarding.statusDELETED": "Deleted",
  "lender.onboarding.statusCANCELLED": "Cancelled",
  "lender.onboarding.filtersButton": "Filters",
  "lender.onboarding.filterAllTypes": "All types",
  "lender.onboarding.filterAllStatuses": "All statuses",
  "lender.onboarding.clearFiltersButton": "Clear filters",
  "lender.onboarding.backToApplications": "Back to applications",
  "lender.onboarding.exitButton": "Exit",

  // --- lender / Onboarding / Application Review ---
  "lender.onboarding.review.stepNewApplication": "New Application",
  "lender.onboarding.review.stepVerification": "Verification",
  "lender.onboarding.review.stepLoanTerms": "Loan Terms",
  "lender.onboarding.review.stepLoanDetailsVerified": "Loan Details Verified",
  "lender.onboarding.review.stepCibil": "CIBIL Verification",
  "lender.onboarding.review.stepEMandate": "E-Mandate",
  "lender.onboarding.review.stepNotification": "Notification Pending",
  "lender.onboarding.review.stepCompleted": "Completed",
  "lender.onboarding.review.rejectButton": "Reject Application",
  "lender.onboarding.review.deleteButton": "Delete Application",
  "lender.onboarding.review.rejectConfirmHeading": "Reject this application?",
  "lender.onboarding.review.rejectConfirmDescription": "The application will be marked as rejected. Captured data stays viewable, but no further edits will be possible.",
  "lender.onboarding.review.deleteConfirmHeading": "Delete this application?",
  "lender.onboarding.review.deleteConfirmDescription": "The application will be marked as deleted. Captured data stays viewable, but no further edits will be possible.",
  "lender.onboarding.review.reasonLabel": "Reason",
  "lender.onboarding.review.reasonPlaceholderReject": "Why is this application being rejected?",
  "lender.onboarding.review.reasonPlaceholderDelete": "Why is this application being deleted?",
  "lender.onboarding.review.reasonRequiredError": "A reason is required.",
  "lender.onboarding.review.actionCancelButton": "Cancel",
  "lender.onboarding.review.actionConfirmButton": "Confirm",
  "lender.onboarding.review.actionConfirmingButton": "Confirming...",
  "lender.onboarding.review.actionGenericError": "Failed to complete this action. Please try again.",
  "lender.onboarding.review.nextStepNotBuiltHeading": "Next step coming soon",
  "lender.onboarding.review.nextStepNotBuiltDescription": "This application has cleared credit verification. The next review step isn't built yet.",
  "lender.onboarding.review.viewingEarlierStepHint": "Viewing a completed step — resubmitting will update this application again.",

  "lender.onboarding.review.applicantProfileHeading": "Applicant Profile",
  "lender.onboarding.review.editProfileButton": "Edit",
  "lender.onboarding.review.saveProfileButton": "Save",
  "lender.onboarding.review.savingProfileButton": "Saving...",
  "lender.onboarding.review.cancelProfileButton": "Cancel",
  "lender.onboarding.review.phoneLabel": "Phone",
  "lender.onboarding.review.emailFormatError": "Enter a valid email address",
  "lender.onboarding.review.phoneFormatError": "Enter a valid 10-digit phone number",
  "lender.onboarding.review.profileUpdateError": "Failed to save applicant profile. Please try again.",
  "lender.onboarding.review.profileLoadError": "Failed to load applicant profile.",

  "lender.onboarding.review.verifyTriggerHeading": "Applicant Verification",
  "lender.onboarding.review.verifyTriggerButton": "Verify Applicant",
  "lender.onboarding.review.verificationDescription": "Send a verification code to the applicant's registered email and phone to confirm their identity before proceeding.",
  "lender.onboarding.review.crifConsentText": "By verifying this OTP, I agree to Lendcord obtaining my Credit Information Report and Credit Score from CRIF High Mark Credit Information Services Pvt. Ltd (CRIF High Mark) for the purpose of rendering financial services.",
  "lender.onboarding.review.sendOtpButton": "Send Verification Code",
  "lender.onboarding.review.sendingOtpButton": "Sending...",
  "lender.onboarding.review.phoneCodeLabel": "Phone Code",
  "lender.onboarding.review.emailCodeLabel": "Email Code",
  "lender.onboarding.review.confirmButton": "Confirm & Continue",
  "lender.onboarding.review.confirmingButton": "Confirming...",
  "lender.onboarding.review.resendOtpButton": "Resend Code",
  "lender.onboarding.review.otpSendError": "Failed to send verification code. Please try again.",
  "lender.onboarding.review.otpRequiredError": "Enter both 6-digit codes to continue.",
  "lender.onboarding.review.otpIncorrectError": "Incorrect code. Please try again.",
  "lender.onboarding.review.otpExpiredError": "This verification session has expired. Please resend the code.",
  "lender.onboarding.review.otpGenericError": "Failed to verify. Please try again.",

  "lender.onboarding.review.loanTermsHeading": "Loan Terms",
  "lender.onboarding.review.loanTypeLabel": "Loan Type",
  "lender.onboarding.review.loanTypePlaceholder": "Select loan type",
  "lender.onboarding.review.loanTypeInterestOnly": "Interest Only",
  "lender.onboarding.review.loanTypeEmi": "EMI",
  "lender.onboarding.review.roiLabel": "ROI (%)",
  "lender.onboarding.review.mandateTypeLabel": "Type of Mandate",
  "lender.onboarding.review.mandateTypePlaceholder": "Select mandate type",
  "lender.onboarding.review.mandateMonthly": "Monthly",
  "lender.onboarding.review.mandateWeekly": "Weekly",
  "lender.onboarding.review.mandateQuarterly": "Quarterly",
  "lender.onboarding.review.installmentsLabel": "Number of Installments",
  "lender.onboarding.review.installmentAmountLabel": "Installment Amount",
  "lender.onboarding.review.installmentAmountPlaceholder": "Estimated installment amount",
  "lender.onboarding.review.startDateLabel": "Installment Start Date",
  "lender.onboarding.review.processingFeeLabel": "Processing Fee (%)",
  "lender.onboarding.review.penaltyLabel": "Installment Penalty",
  "lender.onboarding.review.referencesHeading": "References",
  "lender.onboarding.review.referencesHint": "At least one reference is required; a second is optional.",
  "lender.onboarding.review.referenceNameLabel": "Reference {number} Name",
  "lender.onboarding.review.referenceRelationLabel": "Relation",
  "lender.onboarding.review.referenceRelationPlaceholder": "Select relation",
  "lender.onboarding.review.referenceContactLabel": "Contact Number",
  "lender.onboarding.review.saveAndContinueButton": "Save & Continue",
  "lender.onboarding.review.savingButton": "Saving...",
  "lender.onboarding.review.loanTypeRequiredError": "Loan type is required",
  "lender.onboarding.review.roiRequiredError": "ROI is required",
  "lender.onboarding.review.mandateTypeRequiredError": "Type of mandate is required",
  "lender.onboarding.review.installmentsRequiredError": "Number of installments is required",
  "lender.onboarding.review.startDateRequiredError": "Installment start date is required",
  "lender.onboarding.review.processingFeeRequiredError": "Processing fee is required",
  "lender.onboarding.review.penaltyRequiredError": "Installment penalty is required",
  "lender.onboarding.review.referenceOneRequiredError": "Reference 1's name, relation, and a valid 10-digit contact number are required",
  "lender.onboarding.review.loanTermsSubmitError": "Failed to save loan terms. Please try again.",

  "lender.onboarding.review.crifHeading": "Credit Bureau Check",
  "lender.onboarding.review.crifDescription": "Run a CRIF credit check to continue reviewing this application.",
  "lender.onboarding.review.crifRunButton": "Run Credit Check",
  "lender.onboarding.review.crifRunningButton": "Checking...",
  "lender.onboarding.review.crifRetryButton": "Check Again",
  "lender.onboarding.review.crifRerunButton": "Run Again",
  "lender.onboarding.review.crifPendingMessage": "We couldn't reach the credit bureau just now — retrying automatically…",
  "lender.onboarding.review.crifFailedMessage": "The credit check failed and can't be retried automatically. Please contact support.",
  "lender.onboarding.review.crifCheckError": "Failed to run the credit check. Please try again.",
  "lender.onboarding.review.crifScoreLabel": "CIBIL Score",
  "lender.onboarding.review.crifScoreBandPoor": "Poor",
  "lender.onboarding.review.crifScoreBandFair": "Fair",
  "lender.onboarding.review.crifScoreBandGood": "Good",
  "lender.onboarding.review.crifDecisionLabel": "Recommendation",
  "lender.onboarding.review.crifDecisionApprove": "Approve",
  "lender.onboarding.review.crifDecisionRefer": "Refer for manual review",
  "lender.onboarding.review.crifDecisionReject": "Reject",
  "lender.onboarding.review.crifReasonsHeading": "Reasons",
  "lender.onboarding.review.crifDownloadPdfButton": "Download Report (PDF)",
  "lender.onboarding.review.crifApproveButton": "Approve",
  "lender.onboarding.review.crifApprovingButton": "Approving...",
  "lender.onboarding.review.crifApproveError": "Failed to approve this application. Please try again.",
  "lender.onboarding.review.approvalHeading": "Approval",
  "lender.onboarding.review.approvalDescription": "Review the applicant's details above, then approve to complete onboarding.",
};
